import React from 'react';
import PropTypes from 'prop-types';
import { Export } from '../export';

class ExportBlob extends React.Component {
  handleExport = () => {
    const { handleExport } = this.props;
    handleExport();
  };

  render() {
    return <Export onClickExportCustom={this.handleExport} />;
  }
}

ExportBlob.propTypes = {
  handleExport: PropTypes.func,
};

ExportBlob.defaultProps = {
  handleExport: () => {},
};

export default ExportBlob;
